import type { OzonetelWindow } from '../../consts/ozonetel/sdk';

export function getOzonetelSdk() {
  const ozonetelWindow = window as OzonetelWindow;

  if (ozonetelWindow.dc?.initialize) {
    return ozonetelWindow.dc;
  }

  if (ozonetelWindow.DigitalConsole) {
    ozonetelWindow.dc = new ozonetelWindow.DigitalConsole();
  }

  return ozonetelWindow.dc;
}
